<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <div v-if="allModify" class="page-transparent-bg"></div>

              <div class="row">
                <div class="col-md-7">
                  <div>
                    <label>角色名称</label>
                    <div class="mb-3">
                      <input
                        v-model="item.name"
                        type="text"
                        class="form-control"
                        placeholder="请输入角色名称"
                      />
                    </div>
                    <div class="mb-3">
                      <b-form-checkbox
                        @change="checkedAll"
                        v-model="indeterminate"
                        checked
                        plain
                        >全选</b-form-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-for="(group, index) in groups"
                v-bind:key="index"
              >
                <label>{{ group.title }}</label>
                <div
                  class="col-md-3 mb-3"
                  style="width: 250px"
                  v-for="(data, data_index) in group.subordinates"
                  v-bind:key="data_index"
                >
                  <div class="power-item-main">
                    <div class="power-title">
                      <b-form-checkbox
                        v-model="data.allChecked"
                        checked
                        plain
                        @change="changeChecked(index, data_index)"
                        >{{ data.title }}</b-form-checkbox
                      >
                      <!-- {{ data.title }} -->
                    </div>
                    <div class="power-items">
                      <div
                        class="power-item"
                        v-for="(i, i_index) in data.subordinates"
                        v-bind:key="i_index"
                      >
                        <b-form-checkbox
                          v-model="allPower"
                          :value="i.key"
                          checked
                          plain
                          @change="changeCheckedPower(index, data_index, i)"
                          >{{ i.actionName }}</b-form-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row submit-bar"
              style="
        display: flex;
        align-items: center;
        height: 80px;
        padding-left: 1.25rem;
        padding-bottom: 0;
        padding-top: 0;
        margin-bottom: 0;
      "
            >
              <div class="col-md-12">
                <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
                <div class="bar-handle">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button>
                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    {{ index_id ? "保存" : "创建" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import roles from "@/server/api/roles";
import { PERMISSIONS } from "@/router/views/account/roles/permission.js";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      item: {},
      allPower: [],
      allGroupsKey: [],
      index_id: "",
      indeterminate: false, //全选
      allModify: false,
      groups: PERMISSIONS,
      mediaId: Number(this.$route.query.mediaId),
    };
  },

  mounted() {
    console.log(this.groups);
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.fetch();
    }
    if (this.$route.query.allModify) {
      this.allModify = true;
    }

    if (this.groups.length) {
      let allGroupsKeys = [];
      for (var i = 0; i < this.groups.length; i++) {
        let groups_items = this.groups[i];
        for (var j = 0; j < groups_items.subordinates.length; j++) {
          let data_item = groups_items.subordinates[j];
          for (var k = 0; k < data_item.subordinates.length; k++) {
            allGroupsKeys.push(data_item.subordinates[k].key);
          }
        }
      }
      this.allGroupsKey = allGroupsKeys;
    }
  },

  watch: {
    allPower: function() {
      if (
        this.allPower.length == this.allGroupsKey.length &&
        this.allPower.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  methods: {
    fetch() {
      var params = {
        id: this.index_id,
      };
      roles.detail(params).then((resp) => {
        // console.log("角色详情", resp);
        if (resp.code == 0) {
          let that = this;
          var newMenuKeys = [];
          if (resp.data.menuKeys) {
            for (var i = 0; i < resp.data.menuKeys.length; i++) {
              if (newMenuKeys.indexOf(resp.data.menuKeys[i]) === -1) {
                newMenuKeys.push(resp.data.menuKeys[i]);
              }
            }
          }
          this.allPower = newMenuKeys;
          this.item = resp.data;
          let groupsArr = that.groups;
          for (var i = 0; i < groupsArr.length; i++) {
            let group = groupsArr[i];
            for (var j = 0; j < group.subordinates.length; j++) {
              group.subordinates[j].allChecked = that.groupMenuKey(
                group.subordinates[j].subordinates
              );
            }
          }
          this.groups = groupsArr;
        }
      });
    },

    groupMenuKey(subs) {
      let subordKey = 0;
      for (var i = 0; i < subs.length; i++) {
        for (var j = 0; j < this.allPower.length; j++) {
          if (subs[i].key === this.allPower[j]) {
            subordKey = subordKey + 1;
          }
        }
      }
      return subs.length === subordKey ? true : false;
    },

    changeChecked(index, data_index) {
      let data = this.groups[index].subordinates[data_index];
      if (data.allChecked) {
        for (var i = 0; i < data.subordinates.length; i++) {
          let item = data.subordinates[i];
          this.allPower.push(item.key);
        }
      } else {
        for (var i = 0; i < data.subordinates.length; i++) {
          let item = data.subordinates[i];
          for (var j = 0; j < this.allPower.length; j++) {
            if (item.key === this.allPower[j]) {
              this.allPower.splice(j, 1);
            }
          }
        }
      }
    },

    changeCheckedPower(index, data_index, keyObj) {
      let data = this.groups[index].subordinates[data_index];
      let isPowerNumber = 0;
      let allChecked = false;
      for (var j = 0; j < data.subordinates.length; j++) {
        let subItem = data.subordinates[j];
        for (var i = 0; i < this.allPower.length; i++) {
          let key = this.allPower[i];
          if (key === subItem.key) {
            isPowerNumber = isPowerNumber + 1;
          }
        }
      }
      if (isPowerNumber == data.subordinates.length) {
        allChecked = true;
      }
      this.groups[index].subordinates[data_index].allChecked = allChecked;
      Vue.set(this.groups, index, this.groups[index]);
    },

    submitPreserve() {
      let params = JSON.parse(JSON.stringify(this.item));
      params.type = 2;
      if (!params.name) {
        Vue.swal("请输入角色名称");
        return;
      }
      params.menuKeys = this.allPower;
      if (this.index_id) {
        roles.modify(params).then((resp) => {
          console.log(params, "保存的权限");
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "修改成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      } else {
        params.mediaId = this.mediaId;
        roles.create(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "添加成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    },

    // 列表全选
    checkedAll() {
      this.groups.forEach((v) => {
        v.subordinates.forEach((k) => {
          k.allChecked = false;
          if (this.indeterminate) {
            k.allChecked = true;
          } else {
            k.allChecked = false;
          }
        });
      });
      if (this.indeterminate) {
        this.allPower = this.allGroupsKey;
      } else {
        this.allPower = [];
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.power-item-main {
  border: 1px solid #d8d8d8;
}

.power-item-main .power-title {
  padding: 15px;
  background: #f0f0f0;
}

.power-item-main .power-items {
  padding: 20px 15px;
}

.power-item-main .power-items .power-item {
  padding-bottom: 20px;
}

.power-item-main .power-items .power-item:last-child {
  padding-bottom: 0px;
}
</style>
